import React from 'react';
import { Form } from 'react-bootstrap';

// A required yes/no question: a radio group in a fieldset whose legend is the
// question. `value` is true, false, or null while unanswered.
function YesNoQuestion({ id, legend, value, onChange, invalid, message }) {
    const errorId = `${id}-error`;
    return (
        <fieldset
            role="radiogroup"
            className="mb-3"
            aria-required="true"
            aria-invalid={invalid ? 'true' : undefined}
            aria-describedby={invalid ? errorId : undefined}
        >
            <legend className="form-label fs-6">
                {legend}{' '}
                <span className="text-danger" aria-hidden="true">
                    *
                </span>
            </legend>
            <Form.Check
                type="radio"
                name={id}
                id={`${id}-yes`}
                label="Yes"
                checked={value === true}
                isInvalid={invalid}
                onChange={() => onChange(true)}
            />
            <Form.Check
                type="radio"
                name={id}
                id={`${id}-no`}
                label="No"
                checked={value === false}
                isInvalid={invalid}
                onChange={() => onChange(false)}
            />
            {invalid && (
                <div
                    id={errorId}
                    role="alert"
                    className="invalid-feedback d-block"
                >
                    {message}
                </div>
            )}
        </fieldset>
    );
}

export default YesNoQuestion;
